const inkeep_ai_bot = {
    intro_message: 'Cześć, jestem Logto AI!\n\nJestem asystentem AI szkolonym na dokumentacji, artykułach pomocy i innych treściach.\n\nZapytaj mnie o wszystko związane z `Logto`.',
    chat_placeholder: 'Zadaj pytanie Logto AI, aby uzyskać przewodnik krok po kroku',
    disclaimer_label: 'Zastrzeżenie Logto AI',
    disclaimer_tooltip: 'Odpowiedzi są generowane przez AI i mogą wymagać weryfikacji.',
    example_questions_label: 'Przykładowe pytania',
    example_questions: [
        'Przewodnik szybkiego startu dla konfiguracji Logto',
        'Konfiguracja architektury wielojednostkowej',
        'Jak zintegrować profil użytkownika?',
    ],
    stop: 'Zatrzymaj',
    clear: 'Zacznij od nowa',
    get_help: 'Uzyskaj pomoc',
    copy_chat: 'Kopiuj',
    ask_ai_label: 'Zapytaj AI',
    contact: 'Kontakt',
    discord: 'Discord',
};
export default Object.freeze(inkeep_ai_bot);
